const Logger = {
  event(eventId: string, params?: { [key: string]: any }) {
    if ((window as any)?.TDAPP) {
      (window as any)?.TDAPP.onEvent(eventId, "", params);
    }
  },
};

export default Logger;
